import { EmployeeQcqQualificationResponse, EmployeeQcqQualificationItem } from '@/types/service-response'
import { EmployeeQcqQualificationItemPayload } from '@/types/payload'

export class EmployeeQcqQualification {
  private constructor (
    readonly id: number | null,
    readonly employeeId: number,
    readonly education: string,
    readonly educationId: number | null,
    readonly educationLanguage: number,
    readonly job: string,
    readonly jobId: number | null,
    readonly jobLanguage: number,
    readonly specialization: string,
    readonly specializationId: number | null,
    readonly specializationLanguage: number,
    readonly details: string,
    readonly detailsId: number | null,
    readonly detailsLanguage: number
  ) {}

  public static createFromResponse (data: EmployeeQcqQualificationResponse): Array<EmployeeQcqQualification> {
    let result: Array<EmployeeQcqQualification> = []

    data.forEach((item: EmployeeQcqQualificationItem) => {
      result.push(new EmployeeQcqQualification(
        item.ID,
        item.MitarbeiterID,
        item.bildungsgrade,
        item.bildungsgradeID,
        item.bildungsgradeSprache,
        item.berufes,
        item.berufesID,
        item.berufesSprache,
        item.Fachrichtung,
        item.FachrichtungID,
        item.FachrichtungSprache,
        item.Details,
        item.DetailsID,
        item.DetailsSprache,
      ))
    })

    return result
  }

  public static createFromData (data: EmployeeQcqQualificationItemPayload): EmployeeQcqQualification {
    let result: EmployeeQcqQualification = new EmployeeQcqQualification(
      data.id,
      data.employeeId,
      data.education,
      data.educationId,
      data.educationLanguage,
      data.job,
      data.jobId,
      data.jobLanguage,
      data.specialization,
      data.specializationId,
      data.specializationLanguage,
      data.details,
      data.detailsId,
      data.detailsLanguage
    )
    return result
  }

}